module.exports = __webpack_public_path__ + "static/som-cbcf1d48389f7403d2c5cbfdfc78f078.jpg";